// extracted by mini-css-extract-plugin
module.exports = {"Theme":"solarized_Theme__36Ttp"};